'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Action = Action;

var _Factory = require('./Factory');

var registered = new Set();
function Action(type) {
    if (registered.has(type)) {
        throw Error('action ' + type + ' has already been defined');
    }
    registered.add(type);
    return (0, _Factory.Factory)(type);
}
//# sourceMappingURL=Action.js.map


// WEBPACK FOOTER //
// ./node_modules/@zaibot/fsa/es5/Action.js